import { useRouter } from 'next/router';
import { ServiceType } from '@/__generated__/globalTypes';
import { useSeekerCCState } from '@/components/AppState';
import useFeatureFlag, { FlagName } from '@/components/hooks/useFeatureFlag';
import { CLIENT_FEATURE_FLAGS, VERTICALS_NAMES_TO_SERVICE_TYPE } from '@/constants';
import { ServiceIdsForMember } from '@/types/seekerCC';
import getVertical from '@/utilities/verticalUtils';

const useIsSeekerEnrollment2 = (serviceType?: ServiceType) => {
  const { pathname } = useRouter();
  const { czenServiceIdForMember } = useSeekerCCState();
  let serviceTypeFormatted = serviceType;
  if (!serviceTypeFormatted) {
    const vertical = getVertical(pathname) || '';
    serviceTypeFormatted = VERTICALS_NAMES_TO_SERVICE_TYPE[vertical] || null;
  }

  const LDFlags: Partial<Record<ServiceType, FlagName>> = {
    [ServiceType.CHILD_CARE]: CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_OVERHAUL_CC_M1,
    [ServiceType.PET_CARE]: CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_OVERHAUL_PC_M1,
    [ServiceType.SENIOR_CARE]: CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_OVERHAUL_SC_M1,
    [ServiceType.HOUSEKEEPING]: CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_OVERHAUL_HK_M1,
  };

  // v1 flags for each vertical
  const seekerEnrollment2FlagName = LDFlags?.[serviceTypeFormatted];
  const seekerEnrollment2Flag =
    // eslint-disable-next-line react-hooks/rules-of-hooks
    seekerEnrollment2FlagName && useFeatureFlag(seekerEnrollment2FlagName);
  const isSeekerEnrollment2FlagEnabled = [2, 5, 6].includes(seekerEnrollment2Flag?.value);

  // vertical iteration flags
  const seekerCCFlagV3 = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_OVERHAUL_CC_M1_V3
  );
  const isSeekerCCFlagV3Enabled = [2, 3, 4, 5].includes(seekerCCFlagV3?.value);

  // intent flag
  const seekerOverhaulCCIntentFlag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_OVERHAUL_CC_INTENT
  );
  const isSeekerOverhaulCCIntentEligible = [2, 3].includes(seekerOverhaulCCIntentFlag?.value);

  let isSeekerEnrollment2Eligible = false;
  switch (serviceTypeFormatted) {
    case ServiceType.CHILD_CARE:
      isSeekerEnrollment2Eligible =
        (isSeekerEnrollment2FlagEnabled ||
          isSeekerCCFlagV3Enabled ||
          isSeekerOverhaulCCIntentEligible) &&
        czenServiceIdForMember !== ServiceIdsForMember.dayCare;
      break;
    default:
      isSeekerEnrollment2Eligible = isSeekerEnrollment2FlagEnabled;
      break;
  }

  return {
    seekerEnrollment2FlagName,
    seekerEnrollment2Flag,
    isSeekerEnrollment2Eligible,
  };
};

export default useIsSeekerEnrollment2;
